<template>
    <div class="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <h1 class="text-3xl font-bold text-gray-900 mb-8">Privacy Policy</h1>

        <div class="prose prose-slate max-w-none">
            <p class="mb-4 italic">Effective Date: 02/01/2026</p>

            <p>
                At ClaimReady, we prioritize your privacy above all else. This Privacy Policy outlines how we collect,
                use, and (most importantly) store your data.
            </p>

            <h2 class="mt-8 mb-1 font-semibold">1. Information We Collect</h2>
            <p class="mb-4">
                We do not collect any information about you or your property. Your data is stored locally on your device
                and is not transmitted to our servers. Here's what we collect:
            </p>
            <ul class="mb-4 list-disc list-inside">
                <li class="pl-4"><strong>Payment Information:</strong> Processed securely via Polar.sh. We do not store
                    your credit
                    card details.</li>
                <li class="pl-4"><strong>Email Address:</strong> Used solely to deliver your payment invoice and not
                    stored on our
                    servers.</li>
            </ul>

            <h2 class="mt-8 mb-1 font-semibold">2. How We Store Your Data</h2>
            <p class="mb-4">
                <strong>Client-Side First:</strong> Your inventory data describes your personal property, so it stays on
                your personal device. We use your browser's local storage (IndexedDB) to save your work.
            </p>

            <p class="mb-4">
                <strong>On-Device Processing:</strong> When generating your PDF report, your data is processed in your
                browser and never leaves your device. You're in charge of your data.
            </p>

            <h2 class="mt-8 mb-1 font-semibold">3. Usage of Data</h2>
            <p class="mb-4">Since we don't see your data, we can't use it. Payment information is never stored on our
                servers and does not leave the payment processor's servers.</p>

            <p class="mb-4">Because we don't store your data, we <strong>cannot</strong> sell it to third parties,
                advertisers, or
                insurance companies even if we wanted to.</p>

            <h2 class="mt-8 mb-1 font-semibold">4. Contact Us</h2>
            <p>
                If you have questions about your privacy, please contact us at <a :href="`mailto:${contactEmail}`">{{
                    contactEmail }}</a>.
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
definePageMeta({
    layout: 'default'
})

const contactEmail = "contact@nodeworx.io";
</script>
